import React, { Component } from 'react';

export default class Dropdown extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listVisible: false
    };
    this.hide = this.hide.bind(this);
  }

  componentWillUnmount(){
    this.hide();
  }

	show() {
		this.setState({ listVisible: true });
		document.addEventListener("click", this.hide);
	}


	hide() {
		this.setState({ listVisible: false });
		document.removeEventListener("click", this.hide);
	}


	render() {
		return (
      <div className={"dropdown d-inline-block  " + this.props.direction + (this.state.listVisible ? " show" : "")}>
        {
          React.Children.map(this.props.children,(element,index) => {
            if(index===0){
              return (
                <div className="cursor" onClick={()=>{this.show()}} key={index}>
                  {element.props.children}
                </div>
              )
            }
            if(index===1){
              return (
                <div className={"dropdown-menu shadow-lg "+(this.state.listVisible ? " show" : "")}  key={index}>
                {element.props.children}
                </div>
              )
            }
          })
        }
  		</div>
    )
	}

}



// WEBPACK FOOTER //
// ./src/components/dropdown.js